<template>
  <article>
    <scroller
      lock-x scrollbar-y
      use-pullup
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      height="100%">
      <div>
        <group v-for="(item,index) in visits" :key="index">
          <cell class="personal-info-detail">
            <p slot="after-title">到店时间：{{item.arrive_at}}<span
                class="label">{{item.is_invited === 1 ? '邀约到店' : '自然到店'}}</span></p>
            <p slot="after-title" class="info">姓名：{{item.customer_name}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
            <p slot="after-title" class="info">客流编号：{{item.id}}</p>
          </cell>
          <cell class="acard-btn">
            <x-button v-if="item.relate_customer_id" class="visitor-btn btn-r" slot="value" mini plain type="primary"
                      @click="queryAssociate(item.relate_customer_id)">查看关联
            </x-button>
            <x-button v-if="item.relate_customer_id" class="visitor-btn btn-r" slot="value" mini plain type="primary"
                      @click="addArriveRecord(item.id)">添加到店记录
            </x-button>
            <x-button v-else class="visitor-btn" slot="value" mini plain type="primary"
                      @click="associateCustomer(item.id,item.mobile,item.arrive_at)">关联客户
            </x-button>
          </cell>
        </group>
        <p class="tip-text1">今日已分配的到店客户共{{totalCount}}条</p>
      </div>
    </scroller>
  </article>
</template>
<script>
import {
  Scroller,
  XButton,
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'
// import authApi from '../../../common/auth'

export default {
  components: {
    Scroller,
    XButton,
    Cell,
    Group
  },
  data () {
    return {
      // 客户跟进权限(页面访问权限)
      FollowCustomerAuth: true,
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      localArchivesDataKey: 'customerArchivesLocalData',
      sessionKey: 'customerArrive',
      visits: [],
      page: 1,
      item_per_page: 20,
      totalCount: 10
    }
  },
  mounted () {
    this.$store.state.promiseAuth.then(auth => {
      // let authList = auth.authList
      // this.FollowCustomerAuth = authList.includes(authApi.saleManage.sale_potential_customer_follow_up)
      if (this.FollowCustomerAuth) {
        // 本地客户档案信息.
        cache.clearSessionData(this.localArchivesDataKey)
        this.$rest.saleManage.todayStoreVisit({
          page: this.page,
          item_per_page: this.item_per_page
        }).then(res => {
          if (res.code === 0) {
            this.visits = res.data.visits
            this.totalCount = res.data.total
            this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    queryAssociate (id) {
      if (id) {
        let item = this.visits.find(v => {
          return v.id === id
        })
        cache.setSessionData(this.sessionKey + '_' + id, item)
        this.$router.push('/salemanage/staff/associatecustomer/' + id)
      }
    },
    addArriveRecord (id) {
      if (id) {
        let item = this.visits.find(v => {
          return v.id === id
        })
        cache.setSessionData(this.sessionKey + '_' + id, item)
        this.$router.push('/salemanage/staff/customerarriverecord/' + id)
      }
    },
    associateCustomer (id, mobile, firstArriveTime) {
      if (mobile) {
        this.$rest.saleManage.getCustomerInfoByMobile(null, mobile).then(res => {
          if (res.code === 0) {
            let data = res.data
            if (data.customer) {
              this.$router.push({
                path: '/salemanage/staff/associatecustomer/' + data.customer.id,
                query: { store_visit_id: id }
              })
            } else if (data.clue) {
              this.combineArchives(firstArriveTime)
              this.$router.push({
                path: '/salemanage/staff/showcluearchives/' + data.clue.id,
                query: { store_visit_id: id }
              })
            } else {
              this.combineArchives(firstArriveTime)
              this.$router.push({ path: '/salemanage/staff/showphone', query: { store_visit_id: id } })
            }
          }
        })
      } else {
        this.combineArchives(firstArriveTime)
        this.$router.push({ path: '/salemanage/staff/showphone', query: { store_visit_id: id } })
      }
    },
    loadMore (done) {
      if (this.page < this.totalPage) {
        ++this.page
        this.$rest.saleManage.todayStoreVisit({
          page: this.page,
          item_per_page: this.item_per_page
        }).then(res => {
          if (res.code === 0) {
            this.visits.push(...res.data.visits)
            this.totalCount = res.data.total
            this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
            done(100)
          }
        })
      } else {
        done()
      }
    },
    combineArchives (firstArriveTime) {
      cache.setSessionData(this.localArchivesDataKey, {
        customer: {
          selectAuth: true,
          first_arrive_at: firstArriveTime
        },
        chooseItem: null,
        addressList: [],
        chanelList: []
      })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
